import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getProject, getSampleProject, updateProject } from '@src/apis/project';
import { Box, CircularProgress, useMediaQuery } from '@mui/material';
import { convertBlocksSaveToStore } from '@src/services/project';
import { countTextLength } from '@src/services/tts';
// import Sidebar from './Sidebar';
import theme from '@src/styles/theme';
import actions from '@src/redux/actions';
import { StyledProjectDetail } from './index.style';
import Header from './Header';
import Content from './Content';
import ProjectOnMobile from '../Project/ProjectOnMobile';

const ProjectDetail = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();

  const location = useLocation();
  const projectId = location.pathname.split('/')[2];

  const [loadingProjectDetail, setLoadingProjectDetail] = useState(true);

  const fetchProjectDetail = async () => {
    let response;
    const { isSampleProject } = location.state || {};

    if (isSampleProject) {
      const sampleProject = await getSampleProject();
      const {
        blocks = [],
        title,
        audioType,
      } = sampleProject?.result?.sampleProject || {};
      await updateProject(projectId, {
        title,
        blocks: blocks.map((block) => ({
          id: block.id,
          characters: countTextLength(block.text || ''),
          text: block.text || undefined,
          voiceCode: block.voiceCode,
          breakTime: block.breakTime,
          speed: block.speed,
          elements: block.elements,
          isSample: true,
        })),
        audioType,
      });
      response = sampleProject?.result?.sampleProject;
    } else {
      const detailProject = await getProject(projectId);
      response = detailProject?.result?.project;
    }
    if (response) {
      const {
        blocks = [],
        title,
        createdAt,
        product,
        audioType,
      } = response || {};
      const multiBlock = convertBlocksSaveToStore(blocks);
      dispatch(actions.project.setMultiBlock(multiBlock));
      dispatch(actions.project.setTitle(title));
      dispatch(actions.project.setOriginalTitle(title));
      dispatch(actions.project.setCreatedAt(createdAt));
      dispatch(actions.project.setProduct(product));
      dispatch(actions.project.setProjectId(projectId));
      dispatch(actions.project.setAudioType(audioType));
      dispatch(actions.project.setOriginalAudioType(audioType));
      setLoadingProjectDetail(false);
      // Reset state when user navigate out of project detail
      // so that when user navigate to project detail again
      // the audio won't automatically play.
      dispatch(actions.project.setCurrentBlockId(''));
      dispatch(actions.project.setCurrentPlayingBlockId(''));
      dispatch(actions.project.setIsPlayingBlock(false));
      dispatch(actions.project.setIsPlaying(false));
    }
  };

  useEffect(() => {
    fetchProjectDetail();
  }, []);

  if (isMobile) {
    return (
      <div style={{ padding: '0 16px' }}>
        <ProjectOnMobile />
      </div>
    );
  }

  if (loadingProjectDetail) {
    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <StyledProjectDetail>
      <div className="container-main-panel">
        <Header />
        <Content />
      </div>
    </StyledProjectDetail>
  );
};

export default ProjectDetail;
